import { Token } from 'config/types';
import { ChainIdEnum } from '../network';

const path = '/images/token';

const tokens: Record<string, Token> = {
  AVAX: {
    coinGeckoInfo: {
      id: 'avalanche-2',
    },
    logo: `${path}/avax.png`,
    name: 'AVAX',
    code: 'AVAX',
    network: ChainIdEnum.AVAX,
    isNative: true,
    decimals: 18,
  },
  USDT: {
    coinGeckoInfo: {
      id: 'tether',
    },
    logo: `${path}/usdt.png`,
    name: 'USDT',
    code: 'USDT',
    network: ChainIdEnum.AVAX,
    address: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
    decimals: 6,
    isStable: true,
  },
};

export default tokens;
